// Static test catalogue — static for now, will be replaced with API later
export const TEST_CATEGORIES = [
  'All',
  'Blood Tests',
  'Diabetes',
  'Vitamins',
  'Cardiac',
  'Hormones',
  'Organ Health',
  'Cancer Markers',
];

export const TESTS = [
  {
    id: 1,
    name: 'Complete Blood Count (CBC)',
    code: 'TLPR001',
    category: 'Blood Tests',
    department: 'Haematology',
    method: 'Automated Cell Counter',
    price: 220,
    original: 490,
    tat: '6 hrs',
    paramCount: 24,
    popular: true,
    icon: '🩸',
    tag: 'Most Booked',
    description:
      'Measures red cells, white cells, platelets and haemoglobin. Screens for infections, anaemia, immune disorders and more.',
    disease: 'Anaemia · Infections · Immune Disorders · Leukaemia',
    specialty: 'General Physician · Haematologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Whole Blood',
    sampleVol: '2 mL',
    container: 'EDTA Tube (Lavender Top)',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '06:00 PM',
    cardTag: 'Are you healthy on the inside?',
    outcomes: [
      'Detect anaemia or hidden infection',
      'Understand blood cell health',
      'Spot fatigue causes you cannot see',
      'Screen for immune system issues',
    ],
    parameters: [
      'Haemoglobin (Hb)',
      'RBC Count',
      'WBC Count',
      'Platelet Count',
      'Haematocrit (PCV)',
      'MCV',
      'MCH',
      'MCHC',
      'Differential Count',
      'RDW-CV',
      'PDW',
      'MPV',
    ],
    significance:
      'Most commonly ordered blood test. Evaluates overall health and detects a wide range of disorders.',
    instructions: 'No fasting required. Avoid strenuous exercise before the test.',
    faqs: [
      [
        'Do I need to fast before CBC?',
        'No fasting is required for a Complete Blood Count. You can eat and drink normally before the test.',
      ],
      [
        'What do abnormal CBC results mean?',
        'Low haemoglobin suggests anaemia. Elevated WBC can indicate infection or inflammation. Low platelets may indicate clotting issues.',
      ],
      [
        'How often should I get a CBC?',
        'Once a year as part of your routine checkup. More frequently if managing a known blood disorder.',
      ],
    ],
  },
  {
    id: 2,
    name: 'Thyroid Function Test (TFT)',
    code: 'TLPR002',
    category: 'Hormones',
    department: 'Biochemistry',
    method: 'CLIA',
    price: 500,
    original: 890,
    tat: '6 hrs',
    paramCount: 3,
    popular: true,
    icon: '🦋',
    tag: 'Trending',
    description:
      'Measures T3, T4 and TSH to evaluate thyroid gland function and detect hypo or hyperthyroidism.',
    disease: 'Thyroid Disorders · Hypothyroidism · Hyperthyroidism',
    specialty: 'Endocrinologist · General Physician',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '2 mL',
    container: 'Plain Tube (Red/Yellow Top)',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '05:00 PM',
    cardTag: 'Is your thyroid slowing you down?',
    outcomes: [
      'Find the cause of unexplained weight gain or loss',
      'Understand fatigue that sleep does not fix',
      'Detect mood swings linked to hormones',
      'Screen for hypo- or hyperthyroidism',
    ],
    parameters: ['Triiodothyronine (T3)', 'Thyroxine (T4)', 'Thyroid Stimulating Hormone (TSH)'],
    significance:
      'The thyroid gland controls metabolism, energy and mood. TSH is the most sensitive marker of thyroid dysfunction.',
    instructions: 'No fasting required. Inform the lab of any thyroid medications you take.',
    faqs: [
      ['Is my thyroid slowing me down?', 'A simple TSH, T3 and T4 test answers this clearly.'],
      [
        'Can thyroid problems cause unexplained weight changes?',
        'Yes — hypothyroidism slows metabolism and hyperthyroidism speeds it up.',
      ],
    ],
  },
  {
    id: 3,
    name: 'HbA1c',
    code: 'TLPR003',
    category: 'Diabetes',
    department: 'Biochemistry',
    method: 'HPLC',
    price: 380,
    original: 650,
    tat: '6 hrs',
    paramCount: 1,
    popular: true,
    icon: '🔬',
    tag: 'Popular',
    description:
      'Measures average blood sugar over 3 months. Gold standard for diabetes diagnosis and management.',
    disease: 'Diabetes · Pre-diabetes · Gestational Diabetes',
    specialty: 'Endocrinologist · Diabetologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Whole Blood',
    sampleVol: '2 mL',
    container: 'EDTA Tube (Lavender Top)',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '06:00 PM',
    cardTag: 'What is your 3-month blood sugar picture?',
    outcomes: [
      'Know your average blood sugar, not just today',
      'Detect pre-diabetes before symptoms appear',
      'Track if lifestyle changes are working',
      'Understand your diabetes risk clearly',
    ],
    parameters: ['Glycated Haemoglobin (HbA1c %)'],
    significance:
      'Reflects average blood glucose over 2-3 months. Above 6.5% indicates diabetes; 5.7-6.4% is pre-diabetes.',
    instructions: 'No fasting required. Can be done any time of day.',
    faqs: [
      ['Do I need to fast for HbA1c?', 'No. HbA1c reflects 2–3 months of averages, not current glucose.'],
      ['What is a normal HbA1c?', 'Below 5.7% is normal. 5.7–6.4% is pre-diabetes. 6.5%+ is diabetes.'],
    ],
  },
  {
    id: 4,
    name: 'Vitamin D (25-OH)',
    code: 'TLPR004',
    category: 'Vitamins',
    department: 'Biochemistry',
    method: 'CLIA',
    price: 700,
    original: 1200,
    tat: '6 hrs',
    paramCount: 1,
    popular: true,
    icon: '☀️',
    tag: 'Most Deficient',
    description:
      'Measures Vitamin D levels. Deficiency linked to bone loss, fatigue, low immunity and mood disorders.',
    disease: 'Vitamin D Deficiency · Osteoporosis · Immune Disorders',
    specialty: 'General Physician · Endocrinologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '2 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '04:00 PM',
    cardTag: 'Why are you always tired?',
    outcomes: [
      'Find out if Vitamin D deficiency is draining your energy',
      'Understand bone and immunity health',
      'Detect a silent deficiency affecting 80% of Indians',
      'Know if you need supplements and how much',
    ],
    parameters: ['25-Hydroxy Vitamin D'],
    significance: 'Essential for calcium absorption, bone health, immunity and mood. Above 30 ng/mL is normal.',
    instructions: 'No fasting required.',
    faqs: [
      ['Do I need to fast?', 'No fasting is required for a Vitamin D test.'],
      ['What is a normal level?', 'Above 30 ng/mL is normal. Below 20 ng/mL is deficient.'],
    ],
  },
  {
    id: 5,
    name: 'Lipid Profile',
    code: 'TLPR005',
    category: 'Cardiac',
    department: 'Biochemistry',
    method: 'Enzymatic',
    price: 450,
    original: 800,
    tat: '6 hrs',
    paramCount: 7,
    popular: true,
    icon: '❤️',
    tag: '',
    description: 'Measures cholesterol fractions and triglycerides to assess cardiovascular risk.',
    disease: 'Cardiovascular Disease · Atherosclerosis · Dyslipidaemia',
    specialty: 'Cardiologist · General Physician',
    gender: 'M/F',
    age: 'Above 20',
    homeCol: true,
    walkIn: true,
    fasting: true,
    sampleType: 'Serum',
    sampleVol: '3 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '05:00 PM',
    cardTag: 'How is your heart doing?',
    outcomes: [
      'Know your real heart disease risk not just cholesterol',
      'Detect dangerous LDL levels early',
      'Understand the HDL and LDL balance',
      'Catch risk before a cardiac event happens',
    ],
    parameters: ['Total Cholesterol', 'HDL', 'LDL', 'VLDL', 'Triglycerides', 'Total/HDL Ratio', 'LDL/HDL Ratio'],
    significance: 'Dyslipidaemia is the leading modifiable risk factor for heart attacks and strokes.',
    instructions: '12-hour fasting required. Avoid alcohol for 24 hours before the test.',
    faqs: [
      ['How long do I fast?', '12 hours of fasting is required. Water is permitted.'],
      ['Healthy LDL level?', 'Below 100 mg/dL is optimal. Above 160 mg/dL is high.'],
    ],
  },
  {
    id: 6,
    name: 'Blood Sugar (Fasting)',
    code: 'TLPR006',
    category: 'Diabetes',
    department: 'Biochemistry',
    method: 'GOD-POD',
    price: 120,
    original: 250,
    tat: '4 hrs',
    paramCount: 1,
    popular: true,
    icon: '🍎',
    tag: '',
    description: 'Measures fasting blood glucose to screen for diabetes and pre-diabetes.',
    disease: 'Diabetes · Pre-Diabetes · Hypoglycaemia',
    specialty: 'General Physician · Diabetologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: true,
    sampleType: 'Fluoride Plasma',
    sampleVol: '2 mL',
    container: 'Fluoride Oxalate Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '11:00 AM',
    cardTag: 'Is sugar silently harming you?',
    outcomes: [
      'Find out if you are pre-diabetic right now',
      'Get a clear baseline for diabetes risk',
      'Understand how your body handles glucose',
    ],
    parameters: ['Fasting Blood Glucose'],
    significance: 'Simplest and most widely used screening test for diabetes.',
    instructions: '8-12 hours fasting required. Water is permitted.',
    faqs: [
      ['How long to fast?', '8-12 hours of fasting is required.'],
      ['Normal value?', 'Below 100 mg/dL is normal. 100-125 mg/dL is pre-diabetic.'],
    ],
  },
  {
    id: 7,
    name: 'Liver Function Test (LFT)',
    code: 'TLPR007',
    category: 'Organ Health',
    department: 'Biochemistry',
    method: 'Enzymatic',
    price: 520,
    original: 900,
    tat: '6 hrs',
    paramCount: 11,
    popular: true,
    icon: '🫁',
    tag: '',
    description: 'Evaluates liver enzymes and proteins to detect liver damage or dysfunction.',
    disease: 'Liver Disorders · Hepatitis · Cirrhosis · Jaundice',
    specialty: 'Hepatologist · Gastroenterologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '3 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '05:00 PM',
    cardTag: 'How hard is your liver working?',
    outcomes: [
      'Detect liver stress from food, alcohol or medication',
      'Screen for early fatty liver',
      'Understand jaundice or digestive symptoms',
    ],
    parameters: [
      'Total Bilirubin',
      'Direct Bilirubin',
      'SGOT (AST)',
      'SGPT (ALT)',
      'ALP',
      'GGT',
      'Total Protein',
      'Albumin',
      'Globulin',
      'A/G Ratio',
    ],
    significance: 'The liver is responsible for over 500 functions. Elevated enzymes indicate damage.',
    instructions: 'Avoid alcohol for 24 hours. No specific fasting required.',
    faqs: [
      ['Do I need to fast?', 'No specific fasting required. Avoid alcohol 24 hours prior.'],
      ['What does elevated SGPT mean?', 'Most specific marker for liver cell damage.'],
    ],
  },
  {
    id: 8,
    name: 'Kidney Function Test (KFT)',
    code: 'TLPR008',
    category: 'Organ Health',
    department: 'Biochemistry',
    method: 'Enzymatic',
    price: 480,
    original: 850,
    tat: '6 hrs',
    paramCount: 8,
    popular: true,
    icon: '🫘',
    tag: '',
    description: 'Measures creatinine, urea and other markers to assess kidney filtering efficiency.',
    disease: 'Chronic Kidney Disease · Acute Kidney Injury',
    specialty: 'Nephrologist · General Physician',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '3 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '05:00 PM',
    cardTag: 'Are your kidneys filtering properly?',
    outcomes: [
      'Detect early kidney decline before symptoms appear',
      'Know your creatinine and eGFR',
      'Screen for chronic kidney disease risk',
    ],
    parameters: ['Urea', 'Creatinine', 'Uric Acid', 'eGFR', 'Sodium', 'Potassium', 'Chloride', 'Bicarbonate'],
    significance: 'Rising creatinine and reduced eGFR indicate declining kidney function.',
    instructions: 'No fasting required. Stay well hydrated.',
    faqs: [
      ['Need to fast?', 'No fasting required. Stay hydrated.'],
      ['What does low eGFR mean?', 'Below 60 ml/min/1.73m² suggests chronic kidney disease.'],
    ],
  },
  {
    id: 9,
    name: 'Vitamin B12',
    code: 'TLPR009',
    category: 'Vitamins',
    department: 'Biochemistry',
    method: 'CLIA',
    price: 420,
    original: 750,
    tat: '6 hrs',
    paramCount: 1,
    popular: false,
    icon: '💊',
    tag: '',
    description: 'Deficiency causes fatigue, nerve damage and anaemia — common in vegetarians.',
    disease: 'B12 Deficiency · Pernicious Anaemia · Neuropathy',
    specialty: 'General Physician · Haematologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '2 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '04:00 PM',
    cardTag: 'Is B12 behind your brain fog?',
    outcomes: [
      'Find if nerve tingling or fatigue is B12-linked',
      'Detect a deficiency common in vegetarians',
    ],
    parameters: ['Vitamin B12 (Cobalamin)'],
    significance: 'Essential for nerve function, DNA synthesis and red blood cell production.',
    instructions: 'No fasting required.',
    faqs: [['Need to fast?', 'No fasting required.']],
  },
  {
    id: 10,
    name: 'Iron Studies & Ferritin',
    code: 'TLPR010',
    category: 'Blood Tests',
    department: 'Biochemistry',
    method: 'CLIA',
    price: 650,
    original: 1100,
    tat: '6 hrs',
    paramCount: 4,
    popular: false,
    icon: '⚒️',
    tag: '',
    description: 'Measures serum iron, ferritin and TIBC to diagnose iron deficiency anaemia.',
    disease: 'Iron Deficiency Anaemia · Haemochromatosis',
    specialty: 'General Physician · Haematologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '3 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '04:00 PM',
    cardTag: 'Why are you breathless and tired?',
    outcomes: [
      'Find the root cause of iron-deficiency anaemia',
      'Know if your body iron stores are critically low',
    ],
    parameters: ['Serum Iron', 'TIBC', 'Transferrin Saturation', 'Ferritin'],
    significance: 'Ferritin is the most sensitive marker for iron deficiency.',
    instructions: 'Best collected in the morning.',
    faqs: [['What does low ferritin mean?', 'Indicates iron deficiency before anaemia develops.']],
  },
  {
    id: 11,
    name: 'PSA (Prostate Antigen)',
    code: 'TLPR011',
    category: 'Cancer Markers',
    department: 'Biochemistry',
    method: 'CLIA',
    price: 550,
    original: 950,
    tat: '6 hrs',
    paramCount: 2,
    popular: false,
    icon: '🔬',
    tag: '',
    description: 'Screens for prostate cancer. Recommended for men above 40.',
    disease: 'Prostate Cancer · Prostatitis',
    specialty: 'Urologist · Oncologist',
    gender: 'M',
    age: 'Above 40',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '2 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '03:00 PM',
    cardTag: 'What is your prostate health score?',
    outcomes: ['Screen for prostate cancer, recommended for men 40+', 'Catch early-stage prostate issues'],
    parameters: ['PSA Total', 'PSA Free'],
    significance: 'Elevated levels may indicate cancer, enlargement, or inflammation.',
    instructions: 'Avoid ejaculation and prostate examination 48 hours before the test.',
    faqs: [['Who should get tested?', 'Men above 50, or 40 with family history.']],
  },
  {
    id: 12,
    name: 'C-Reactive Protein (CRP)',
    code: 'TLPR012',
    category: 'Blood Tests',
    department: 'Biochemistry',
    method: 'Turbidimetry',
    price: 320,
    original: 580,
    tat: '6 hrs',
    paramCount: 1,
    popular: false,
    icon: '🧬',
    tag: '',
    description: 'Detects systemic inflammation. Elevated levels indicate infection or autoimmune disease.',
    disease: 'Inflammation · Infections · Rheumatoid Arthritis',
    specialty: 'General Physician · Rheumatologist',
    gender: 'M/F',
    age: 'All',
    homeCol: true,
    walkIn: true,
    fasting: false,
    sampleType: 'Serum',
    sampleVol: '2 mL',
    container: 'Plain Tube',
    schedule: 'M,Tu,W,Th,F,S',
    cutoff: '05:00 PM',
    cardTag: 'Is hidden inflammation driving your symptoms?',
    outcomes: ['Detect systemic inflammation you cannot feel yet', 'Understand joint pain and fatigue'],
    parameters: ['C-Reactive Protein'],
    significance: 'Acute-phase protein produced by the liver in response to inflammation.',
    instructions: 'No special preparation required.',
    faqs: [['Normal value?', 'Below 10 mg/L is normal.']],
  },
];

export const getTestById = (id) => TESTS.find((t) => t.id === Number(id));
export const getPopularTests = () => TESTS.filter((t) => t.popular);
export const getTestsByCategory = (cat) =>
  cat === 'All' ? TESTS : TESTS.filter((t) => t.category === cat);
